export enum SMTPSettingEnum {
    none = 0,
    autoAlert = 1,
    custom = 2
}


